module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_f_normal.ffa999ab.png";